import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class MoistureContentWCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (MoistureContentWCalculationMethodModel._instance == null) MoistureContentWCalculationMethodModel._instance = new MoistureContentWCalculationMethodModel(authManager);
        return MoistureContentWCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/moisture-content-w-calculation-methods', 'geo-sections/moisture-content-w-calculation-methods/codelist');

        this.entityName = 'geo-sections.MoistureContentWCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Moisture Content W Calc Method';
        this.setLabel = 'Moisture Content W Calc Methods';

        this.browser = {
            name: 'default-geo-sections-moisturecontentwcalculationmethod-browser',
            moduleName: 'default-geo-sections-moisturecontentwcalculationmethod-browser',
            moduleTitle: 'Moisture Content W Calc Methods',
            moduleStateSlotName: 'default-geo-sections-moisturecontentwcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-moisturecontentwcalculationmethod-editor',
            moduleName: 'default-geo-sections-moisturecontentwcalculationmethod-editor',
            moduleTitle: 'Moisture Content W Calc Method',
            moduleStateSlotName: 'default-geo-sections-moisturecontentwcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
